import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'
import './components/Modal.css'
import App from './App.tsx'

// For development testing - expose Supabase client to window
import { supabase } from './config/supabase'

// Make Supabase available for browser testing in development
if (import.meta.env.DEV) {
  (window as any).supabase = supabase;
  (window as any).sb = supabase; // Alternative short name
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
